(function () {
  var WEEKEND_DAYS = ['Sat', 'Sun'];

  function getTimePartsInZone(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    var parts = formatter.formatToParts(date);
    var map = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        map[part.type] = part.value;
      }
    });

    return {
      weekday: map.weekday,
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day),
      hour: Number(map.hour),
      minute: Number(map.minute),
      second: Number(map.second)
    };
  }

  function formatUnit(value) {
    return String(value).padStart(2, '0');
  }

  function updateShippingTimer(timer) {
    var cutoffHour = Number(timer.dataset.cutoffHour || 15);
    var cutoffMinute = Number(timer.dataset.cutoffMinute || 0);
    var timeZone = timer.dataset.timezone || 'America/Los_Angeles';

    var now = new Date();
    var zonedNow = getTimePartsInZone(now, timeZone);

    var beforeEl = timer.querySelector('[data-before-cutoff-message]');
    var afterEl = timer.querySelector('[data-after-cutoff-message]');
    var weekendEl = timer.querySelector('[data-weekend-message]');

    // Saturday 00:00 through Sunday 23:59 in the configured zone. Nothing leaves
    // the warehouse until Monday, so a countdown to today's cutoff would be a lie.
    var isWeekend = WEEKEND_DAYS.indexOf(zonedNow.weekday) !== -1;

    if (weekendEl) {
      weekendEl.classList.toggle('is-hidden', !isWeekend);
    }

    // A timer without a weekend block keeps its original two-state behaviour
    if (isWeekend && weekendEl) {
      if (beforeEl) beforeEl.classList.add('is-hidden');
      if (afterEl) afterEl.classList.add('is-hidden');
      return;
    }

    var currentSeconds = (zonedNow.hour * 60 * 60) + (zonedNow.minute * 60) + zonedNow.second;
    var cutoffSeconds = (cutoffHour * 60 * 60) + (cutoffMinute * 60);

    var isAfterCutoff = currentSeconds >= cutoffSeconds;

    if (beforeEl && afterEl) {
      beforeEl.classList.toggle('is-hidden', isAfterCutoff);
      afterEl.classList.toggle('is-hidden', !isAfterCutoff);
    }

    if (!isAfterCutoff) {
      var remainingSeconds = cutoffSeconds - currentSeconds;
      var hours = Math.floor(remainingSeconds / 3600);
      var minutes = Math.floor((remainingSeconds % 3600) / 60);
      var seconds = remainingSeconds % 60;

      var hoursEl = timer.querySelector('[data-hours]');
      var minutesEl = timer.querySelector('[data-minutes]');
      var secondsEl = timer.querySelector('[data-seconds]');

      if (hoursEl) hoursEl.textContent = formatUnit(hours);
      if (minutesEl) minutesEl.textContent = formatUnit(minutes);
      if (secondsEl) secondsEl.textContent = formatUnit(seconds);
    }
  }

  function initShippingTimers() {
    var timers = document.querySelectorAll('.fuel-shipping-timer:not([data-timer-initialized])');

    timers.forEach(function (timer) {
      timer.setAttribute('data-timer-initialized', 'true');
      updateShippingTimer(timer);

      setInterval(function () {
        updateShippingTimer(timer);
      }, 1000);
    });
  }

  function startShippingTimerLoop() {
    initShippingTimers();
    setInterval(initShippingTimers, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startShippingTimerLoop);
  } else {
    startShippingTimerLoop();
  }
})();
